import React from 'react';

/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */

export const generateLinkTags = linkObjects => {
  let linkTags;
  if (Array.isArray(linkObjects) && linkObjects.length) {
    linkTags = linkObjects.map(linkObject => {
      const additionalAttributes = {};
      if (linkObject.as) {
        additionalAttributes.as = linkObject.as;
      }
      if (linkObject.type) {
        additionalAttributes.type = linkObject.type;
      }
      if (linkObject.crossOrigin) {
        additionalAttributes.crossOrigin = linkObject.crossOrigin;
      }
      if (linkObject.fetchPriority) {
        additionalAttributes.fetchPriority = linkObject.fetchPriority || 'auto';
      }
      return (
        <link
          href={linkObject?.href}
          rel={linkObject?.rel}
          {...additionalAttributes}
        />
      );
    });
  }
  return linkTags ? <>{linkTags}</> : null;
};

export const generateScriptTags = scriptObjects => {
  const keysAllowed = [
    'type',
    'async',
    'defer',
    'chat',
    'key',
    'src',
    'noModule',
    'data-ad-client',
    'crossOrigin',
    'charset',
    'data-domain-script',
  ];
  let inlineScriptTags;

  if (Array.isArray(scriptObjects) && scriptObjects.length) {
    inlineScriptTags = scriptObjects.map(scriptObject => {
      if (
        !(typeof scriptObject === 'object') ||
        !(scriptObject.htmlString || scriptObject.src) ||
        !scriptObject.condition
      ) {
        return null;
      }
      const attributes = {};
      Object.keys(scriptObject).forEach(attr => {
        if (keysAllowed.includes(attr)) {
          attributes[attr] = scriptObject[attr];
        }
      });

      if (scriptObject.htmlString) {
        attributes.dangerouslySetInnerHTML = {
          __html: scriptObject.htmlString,
        };
      }

      return <script {...attributes} />;
    });
  }
  return inlineScriptTags ? <>{inlineScriptTags}</> : null;
};

export const getToiAdsPath = toiadsFile => {
  let toiAdsReactPath = '/toiads_prebid/minify-1.cms';
  switch (toiadsFile) {
    case 'hpRND':
      toiAdsReactPath = '/toiads_react_dfp_rnd/minify-1.cms';
      break;
    default:
      if (toiadsFile) {
        toiAdsReactPath = `/${toiadsFile}/minify-1.cms`;
      }
      break;
  }
  return toiAdsReactPath;
};

const isEqual = (sourceValue, currentValue, matchWhenEmpty = false) => {
  if (!sourceValue) {
    return matchWhenEmpty;
  } else if (Array.isArray(sourceValue)) {
    if (sourceValue.length) {
      return sourceValue.includes(currentValue);
    }
    return matchWhenEmpty;
  }
  return sourceValue === currentValue;
};

export const getValidCWVReportingActiveConfigs = (
  cWVReportingActiveConfigs = [],
  params = {},
) =>
  cWVReportingActiveConfigs.find(config => {
    const { pages, sections, platforms } = config || {};
    return (
      isEqual(pages, params.pageName) &&
      isEqual(sections, params.sectionName, true) &&
      isEqual(platforms, params.platform, true)
    );
  });
